import './Footer.scss';

function Footer() {
    return (
        <footer>
            <div className='container'>
                <p className='footer-text'>Copyright © 2023 Roman Azimov. All Rights Reserved</p>
            </div>
        </footer>
    );
}

export default Footer;